import { SxProps } from "@mui/material";
import { Parameter } from "../../../common/types/parameters";
import { Column } from "../types";
import ParameterSection from "../parameter-section";
import { showWhenSupplementalDistrictHeatingCondition } from "../supplemental-heating.util";

export default function Common(params: {
  description?: string;
  printTitle: string;
  parameters: Parameter[];
  includeVat: boolean;
  toPrint: boolean;
  onValidParameterChange?: (id: string, value: string) => void;
  sx?: SxProps;
}) {
  return (
    <ParameterSection
      printTitle={params.printTitle}
      description={params.description}
      parameters={params.parameters}
      columns={columns}
      toPrint={params.toPrint}
      includeVat={params.includeVat}
      onValidParameterChange={params.onValidParameterChange}
      sx={params.sx}
    />
  );
}

const columns: Column[] = [
  {
    sections: [
      { title: "Behov", parameters: ["AnnualHeatingDemand"] },
      { title: "Spetsvärme", parameters: ["SupplementalHeatingSource"] },
    ],
  },
  {
    sections: [
      {
        title: "Ekonomiska förutsättningar",
        parameters: [
          "VATSelection",
          "InterestRate",
          "ElectricityPriceVariable",
        ],
      },
      {
        title: "",
        parameters: [
          "GridFusePriceFixed",
          "GridFusePriceVariableLow",
          "GridFusePriceVariableHigh",
        ],
      },
      {
        title: "",
        parameters: [
          "GridPowerPriceFixed",
          "GridPowerPriceLoadLow",
          "GridPowerPriceLoadHigh",
          "GridPowerPriceVariableHigh",
          "GridPowerPriceVariableLow",
        ],
      },
      {
        title: "",
        parameters: [
          "SupplementalDistrictHeatingLoadPriceFixed",
          "SupplementalDistrictHeatingLoadPriceVariable",
          "SupplementalDistrictHeatingMaxLoadPriceVariable",
          "SupplementalDistrictHeatingLoadPriceThresholdTable",
          "SupplementalDistrictHeatingEnergyPriceJanuary",
          "SupplementalDistrictHeatingEnergyPriceFebruary",
          "SupplementalDistrictHeatingEnergyPriceMarch",
          "SupplementalDistrictHeatingEnergyPriceApril",
          "SupplementalDistrictHeatingEnergyPriceMay",
          "SupplementalDistrictHeatingEnergyPriceJune",
          "SupplementalDistrictHeatingEnergyPriceJuly",
          "SupplementalDistrictHeatingEnergyPriceAugust",
          "SupplementalDistrictHeatingEnergyPriceSeptember",
          "SupplementalDistrictHeatingEnergyPriceOctober",
          "SupplementalDistrictHeatingEnergyPriceNovember",
          "SupplementalDistrictHeatingEnergyPriceDecember",
          "SupplementalDistrictHeatingMaxEnergyPriceJanuary",
          "SupplementalDistrictHeatingMaxEnergyPriceFebruary",
          "SupplementalDistrictHeatingMaxEnergyPriceMarch",
          "SupplementalDistrictHeatingMaxEnergyPriceApril",
          "SupplementalDistrictHeatingMaxEnergyPriceMay",
          "SupplementalDistrictHeatingMaxEnergyPriceJune",
          "SupplementalDistrictHeatingMaxEnergyPriceJuly",
          "SupplementalDistrictHeatingMaxEnergyPriceAugust",
          "SupplementalDistrictHeatingMaxEnergyPriceSeptember",
          "SupplementalDistrictHeatingMaxEnergyPriceOctober",
          "SupplementalDistrictHeatingMaxEnergyPriceNovember",
          "SupplementalDistrictHeatingMaxEnergyPriceDecember",
          "SupplementalDistrictHeatingAnnualEnergyPriceWithoutDiscount",
          "SupplementalDistrictHeatingAnnualEnergyDiscountPrice",
          "SupplementalDistrictHeatingMaintenencePriceFixed",
          "SupplementalDistrictHeatingMaintenencePriceVariable",
          "SupplementalDistrictHeatingMaintenencePriceThresholdTable",
          "SupplementalDistrictHeatingCentralPriceFixed",
          "SupplementalDistrictHeatingCentralPriceVariable",
          "SupplementalDistrictHeatingConnectionPriceFixed",
          "SupplementalDistrictHeatingConnectionPriceVariable",
          "SupplementalDistrictHeatingFlowPriceJanuary",
          "SupplementalDistrictHeatingFlowPriceFebruary",
          "SupplementalDistrictHeatingFlowPriceMarch",
          "SupplementalDistrictHeatingFlowPriceApril",
          "SupplementalDistrictHeatingFlowPriceMay",
          "SupplementalDistrictHeatingFlowPriceJune",
          "SupplementalDistrictHeatingFlowPriceJuly",
          "SupplementalDistrictHeatingFlowPriceAugust",
          "SupplementalDistrictHeatingFlowPriceSeptember",
          "SupplementalDistrictHeatingFlowPriceOctober",
          "SupplementalDistrictHeatingFlowPriceNovember",
          "SupplementalDistrictHeatingFlowPriceDecember",
          "SupplementalDistrictHeatingAnnualFlowPrice",
        ],
        conditions: [showWhenSupplementalDistrictHeatingCondition],
      },
    ],
  },
];
